import {
  MESSAGE_TYPES
} from '../../config/constants'

const {ADVERTISEMENT_BOT} = MESSAGE_TYPES

export default (messages, groupChat, isEnabledForModeratedChat) => {
  if (!messages) return messages
  if (!groupChat || !groupChat.get || !groupChat.get('key')) return messages

  const isModerated = groupChat.get('isModerated')

  if (isModerated !== true) return messages
  if (isEnabledForModeratedChat === true) return messages

  return messages.filterNot((m) => m.get('type') === ADVERTISEMENT_BOT)
}


/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/filter_hidden_advertisement_candidates.js
 **/